import classnames from 'classnames'
import { Link } from 'gatsby'
import * as React from 'react'
import styleClasses from './btn-changelog.module.scss'

const BtnChangeLog: React.FC<{ className?: string }> = ({ className }) => (
  <Link className={classnames(className, styleClasses.changelog)} to="/changelog">
    CHANGELOG
  </Link>
)

export default BtnChangeLog
